module.exports = function() {
  $(document).trigger('show:weixin-overlay')
}
